import React, { useEffect, useRef } from "react";
import { SidebarPopupWrapper } from "./style";

function SidebarPopup({ children, close = () => {}, title = "hgh" ,randerInput=null,randerFooter=null,bodyStyle={}}) {
  const popupRef = useRef(null);

  useEffect(() => {
  
    document.body.style.overflow = "hidden";

    return () => {
  
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <SidebarPopupWrapper>
      <div className="close" onClick={close}></div>
      <div className="sidebar">
        <div className="sidebarHeader gap10">
          <div className="left flex gap10 " style={{flex: "1 1", justifyContent:"space-between"}}>
            <h2>{title}</h2>
            {randerInput && randerInput}
          </div>
          <div className="right" onClick={close}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.523"
              height="19.523"
              viewBox="0 0 19.523 19.523"
            >
              <g
                id="Group_1107"
                dataName="Group 1107"
                transform="translate(1.414 1.414)"
              >
                <line
                  id="Line_147"
                  dataName="Line 147"
                  y2="23.609"
                  transform="translate(16.694 0) rotate(45)"
                  fill="none"
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-width="2"
                />
                <line
                  id="Line_148"
                  dataName="Line 148"
                  y1="23.609"
                  transform="translate(16.694 16.694) rotate(135)"
                  fill="none"
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-width="2"
                />
              </g>
            </svg>
          </div>
        </div>
        <div className="body" style={bodyStyle}>{children}</div>
        {randerFooter && <div className="SidebarFooter">{randerFooter}</div>}
      </div>

    </SidebarPopupWrapper>
  );
}

export default SidebarPopup;
